// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cs-react .btn-ts-file-upload{margin-bottom:0;height:auto}.cs-react .hidden-input{position:fixed !important;top:-200em !important}.cs-react .margin-top-4{margin-top:4px}.cs-react .btn.block{display:block}\n", ""]);
// Exports
module.exports = exports;
